<template>
  <div>
    <contacts-left-menu/>

    <router-view></router-view>
  </div>
</template>
<script>
  import ContactsLeftMenu from './ContactsLeftMenu';
  export default {
    name: 'ecommerce-layout',
    components: {
      ContactsLeftMenu
    }
  }
</script>
<style>
</style>
